(ns ui.sticker-dialogs.poll
  "The Replicant poll sticker dialog: a question and two to four
   answers in the Instagram poll look, in one of the poll colors."
  (:require [storrito.editor.sticker-design :as sticker-design]
            [ui.sticker-dialogs.actions :as actions]
            [ui.sticker-dialogs.emoji-picker :as emoji-picker]
            [ui.sticker-dialogs.model :as model]
            [ui.sticker-dialogs.ui :as ui]))

(def sticker-shadow
  "0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)")

(defn px
  "Scales the Instagram sticker measures (of a 400px wide sticker) to
   the 350px wide preview."
  [size]
  (str (* (/ 350 400) size) "px"))

(defn color-key
  [hex]
  (some (fn [[k v]]
          (when (= v hex) k))
        sticker-design/poll-v2-colors))

(def question-id
  "sticker-poll-question")

(defn initial-state
  [{:keys [data]}]
  {:question (or (:question data) "WHAT DO YOU THINK?")
   :tallies (model/poll-tallies data)
   :color (or (:color data) "black")})

(defn submit-data
  [dialog]
  (when-let [data (model/valid-poll dialog)]
    [:poll-sticker "Poll Sticker" data]))

(defn question-panel
  [dialog]
  [:div.relative.flex.items-center.justify-center.font-bold
   {:style {:word-break "break-word"
            :min-height (px 71)
            :max-height (px 150)
            :width "100%"
            :padding "16px"
            :border-top-left-radius (px 12)
            :border-top-right-radius (px 12)
            :background-color (get sticker-design/poll-v2-colors (:color dialog))}}
   [:div.relative
    (ui/text-field dialog
                   {:tag :textarea
                    :field :question
                    :dom-id question-id
                    :rows 3
                    :autofocus? true
                    :class ["block" "font-bold" "text-white"]
                    :style {:word-break "break-word"
                            :line-height 1.05
                            :border "hidden"
                            :width (px 350)
                            :font-size (px 30)
                            :font-family "AvenyT"
                            :text-align "center"
                            :resize "none"
                            :background-color "rgba(0,0,0,0)"}})
    (ui/emoji-button {:field :question
                      :dom-id question-id
                      :class (conj ui/emoji-button-inside-css "text-white")})]
   (emoji-picker/panel dialog :question)])

(defn tally-panel
  [dialog idx]
  (let [text (get-in dialog [:tallies idx :text])
        dom-id (str "sticker-poll-tally-" idx)
        field [:tallies idx]]
    [:div.notranslate.relative.flex.items-center.justify-center
     {:replicant/key idx
      :class (if (ui/blank? text)
               ["border-dashed" "border-2"]
               ["bg-gray-200"])
      :style {:user-select "none"
              :width (px 344)
              :height (px 64)
              :border-radius (px 33)
              :color "black"
              :margin-top (px 10)
              :margin-bottom (px 10)}}
     [:div.relative
      {:style {:opacity (when (ui/blank? text) 0.2)}}
      (ui/text-field dialog
                     {:tag :textarea
                      :field field
                      :dom-id dom-id
                      :rows 2
                      :style {:word-break "break-word"
                              :resize "none"
                              :font-size (px 20)
                              :font-family "Roboto"}})
      (ui/emoji-button {:field field
                        :dom-id dom-id
                        :class ui/emoji-button-inside-css})]
     (emoji-picker/panel dialog field)]))

(defn panel
  [dialog]
  (let [valid? (some? (model/valid-poll dialog))]
    [:div.flex.flex-col.gap-2
     [:div.text-3xl.font-extrabold.text-gray-900 "Add a Poll"]
     [:form.m-0.flex.flex-col.items-center
      {:on {:submit [[:js/prevent-default]
                     [:sticker-dialog/submit]]}}
      (ui/color-palette {:colors (vals sticker-design/poll-v2-colors)
                         :value (get sticker-design/poll-v2-colors (:color dialog))
                         :action-fn (fn [color]
                                      [[:sticker-dialog/assoc :color (color-key color)]])})
      [:div.relative.flex.flex-col.justify-between.items-center
       {:style {:box-shadow sticker-shadow
                :width (px 391)
                :min-height (px 269)
                :border-radius (px 12)}}
       (question-panel dialog)
       [:div.flex.flex-col
        {:style {:min-height (px 198)
                 :padding "11px 0"}}
        (map (partial tally-panel dialog)
             (range (count (:tallies dialog))))]]
      [:span.mt-3 ui/instagram-note]
      [:div.mt-4.w-full.justify-end.flex
       (ui/primary-button {:type "submit"
                           :disabled (not valid?)}
                          "Add Poll")]]]))

(defn render
  [state]
  (when-let [dialog (actions/dialog state)]
    (panel dialog)))

(def modal
  {:modal-id :modals/editor2-poll-modal
   :on-load (fn [_state] [[:sticker-dialog/init :poll]])
   :sticker/kind :poll
   :sticker/single-asset-type :poll-sticker
   :sticker/initial-state #'initial-state
   :sticker/submit-data #'submit-data
   :render #'render})

(def register
  [modal])
